import { render, staticRenderFns } from "./AssignFormulationStockPopUp.vue?vue&type=template&id=244b83f1&scoped=true&"
import script from "./AssignFormulationStockPopUp.vue?vue&type=script&lang=js&"
export * from "./AssignFormulationStockPopUp.vue?vue&type=script&lang=js&"
import style0 from "./AssignFormulationStockPopUp.vue?vue&type=style&index=0&id=244b83f1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244b83f1",
  null
  
)

export default component.exports